import { IAppConfig } from 'portalServices';
import { environment } from '../../environments/environment';

export function getServiceConfig(): IAppConfig
{
    const serviceConfig: IAppConfig = {
        apiEndpoint: environment.apiUrl,
        domainName: environment.domainName || window.location.host
    };

    return serviceConfig;
}